/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class WebServicesService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.WEBSERVICES_LISTALL_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServiceConstant.WEBSERVICES_GET, {idWebService: params.idWebService});
  }
  static add(params) {
    return this.postSEC(ServiceConstant.WEBSERVICES_ADD, params);
  }
  static delete(params) {
    return this.postSEC(ServiceConstant.WEBSERVICES_DELETE, params);
  }
  static update(params) {
    return this.postSEC(ServiceConstant.WEBSERVICES_UPDATE, params);
  }
  static listAll(){
    return this.getSEC(ServiceConstant.MASTOGRAPHYFINDING_LISTALL);
  }
}
